import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Employee } from '@shared/models';
import {
  CreateEmployeeRequest,
  EmployeeService,
  UpdateEmployeeRequest,
} from '@app/resources/services/employee.service';

@Injectable()
export class EmployeesApiService {
  private readonly employeeService = inject(EmployeeService);

  getByMerchantId(merchantId: number): Observable<Employee[]> {
    return this.employeeService.findByMerchantId(merchantId).pipe(
      map((result: any) => {
        const values = result?.$values ?? [];
        return values.map(mapToEmployee);
      })
    );
  }

  getByIdAndMerchantId(employeeId: number, merchantId: number): Observable<Employee | null> {
    return this.employeeService
      .findByIdAndMerchantId(employeeId, merchantId)
      .pipe(map((result: any) => (result ? mapToEmployee(result) : null)));
  }

  create(createEmployeeRequest: CreateEmployeeRequest): Observable<Employee | null> {
    return this.employeeService
      .create(createEmployeeRequest)
      .pipe(map((result: any) => (result ? mapToEmployee(result) : null)));
  }

  update(employeeId: number, updateEmployeeRequest: UpdateEmployeeRequest): Observable<Employee | null> {
    return this.employeeService
      .update(employeeId, updateEmployeeRequest)
      .pipe(map((result: any) => (result ? mapToEmployee(result) : null)));
  }

  impersonate(employeeId: number): Observable<string | null> {
    return this.employeeService.impersonate(employeeId).pipe(map((result: any) => result?.jwt ?? null));
  }

  resendWelcomeEmail(employeeId: number): Observable<boolean> {
    return this.employeeService.resendWelcomeEmail(employeeId);
  }
}

function mapToEmployee(data: any): Employee {
  return {
    EmployeeId: data.employeeId,
    NameFirst: data.nameFirst,
    NameLast: data.nameLast,
    EmailAddress: data.emailAddress,
    PhoneNumber: data.phoneNumber,
    AccessType: data.accessType ?? undefined,
    LanguageType: data.languageType ?? undefined,
    LocationIds: data.locationIds?.$values ?? data.locationIds ?? [],
    Pin: data.pin ?? null,
  };
}
